// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".alert.alert-light[data-v-4dcd1b06]{font-style:italic}.alert.alert-light.with-icon[data-v-4dcd1b06]{font-style:normal}.alert.alert-light.with-icon .icon-info[data-v-4dcd1b06]{color:#0a72cc;font-size:24px;padding-right:.75rem}.alert-light[data-v-4dcd1b06]{color:#1a1a1a}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
